import axios from "axios";

const BASE_URL = "https://www.cwsmanager.de:8000";

axios.defaults.baseURL = `${BASE_URL}`;
axios.defaults.headers.post["Content-type"] = "application/json";
const baseURL =  `${BASE_URL}`;

export const fetchData = (method, url, data) => {
    // Retrieve credentials from localStorage
    const username = localStorage.getItem('username');
    const password = localStorage.getItem('password');

    // Set the default headers with the credentials if they exist
    const headers = {
        "Content-Type": "application/json",
    };

    // If username and password are available, include them in the request
    if (username && password) {
        headers['Authorization'] = `Basic ${btoa(username + ':' + password)}`; // Using Basic Auth
    }

    return axios({
        method: method,
        url: url,
        data: data,
        headers: headers,
    });
};
export const UploadData = async (url, options) => {
    const username = localStorage.getItem('username');
    const password = localStorage.getItem('password');
    
    // Initialize headers object
    const headers = {};

    // Add Basic Auth if credentials exist
    if (username && password) {
        headers['Authorization'] = `Basic ${btoa(username + ':' + password)}`;
    }

    // Include headers in options, merging with any additional headers from the caller
    const fetchOptions = {
        ...options, // options passed from caller (like method, body)
        headers: {
            ...headers, // Add auth headers
            ...(options.headers || {}), // Include any other headers from the caller
        },
    };
    const fetchurl = `${baseURL}${url}`
    try {
        const response = await fetch(fetchurl, fetchOptions);

        if (!response.ok) {
            const errorMessage = await response.text();
            throw new Error(`Upload failed: ${errorMessage}`);
        }

        return await response.text(); // Assuming the backend returns a JSON response
    } catch (error) {
        console.error("Error in UploadData:", error);
        throw error;
    }
};
